import { withInstall } from '../../../utils/with-install'
import HexagonLayer from './HexagonLayer.vue'

export const ElAmapLocaHexagon = withInstall(HexagonLayer)
export default ElAmapLocaHexagon
